import axios from 'axios';
// import sessionService from 'services/session'
import {SessionService} from 'services/SessionService'
import ses from "services/session";
import BASE_API from "./services/BaseApi";


let session = new SessionService();

let restApi = axios.create({
    baseURL: BASE_API,
    // baseURL: 'http://localhost:8080/api/',
    // baseURL: 'https://terminmasterapi.in.rs/api/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': ses.getLocale(),
        'Access-Control-Allow-Origin': '*'
    }
});

restApi.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

restApi.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if ((error.response.status === 401 || error.response.status === 403) && !window.location.href.includes('login')) {
            return session.handleErrorResponse(error);
        }else if((error.response.status === 401 || error.response.status === 403) && window.location.href.includes('login')){
            return session.handleLoginErrorResponse(error)
        }else if(error.response.status === 409 && error.response.data.error_description.includes('Morate da prihvatite uslove')){
            return session.handleAcceptTermsErrorResponse(error)
        } else {
            return Promise.reject(error.response);
        }
    }
);

export default restApi



// WEBPACK FOOTER //
// ./src/http-common.js